var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalTalkTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Total_Talk_Time"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Total_Talk_Time",
    clipPath: "url(#clip-Total_Talk_Time)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-headset",
    "data-name": "Icon awesome-headset",
    d: "M8.25,8.937A1.375,1.375,0,0,0,6.875,7.562H6.188a2.75,2.75,0,0,0-2.75,2.75v2.063a2.75,2.75,0,0,0,2.75,2.75h.688A1.375,1.375,0,0,0,8.25,13.75Zm7.562,6.187a2.75,2.75,0,0,0,2.75-2.75V10.312a2.75,2.75,0,0,0-2.75-2.75h-.687A1.375,1.375,0,0,0,13.75,8.937V13.75a1.375,1.375,0,0,0,1.375,1.375ZM11,0A11.209,11.209,0,0,0,0,11v.688a.687.687,0,0,0,.688.688h.688a.687.687,0,0,0,.687-.687V11a8.937,8.937,0,1,1,17.875,0h-.005c0,.1.005,7.121.005,7.121a1.817,1.817,0,0,1-1.817,1.817H13.75a2.062,2.062,0,0,0-2.062-2.062H10.312a2.063,2.063,0,0,0,0,4.125h7.808A3.879,3.879,0,0,0,22,18.121V11A11.209,11.209,0,0,0,11,0Z",
    transform: "translate(4 4)",
    fill: "#fcf8f8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalTalkTime);
export default __webpack_public_path__ + "static/media/Total_Talk_Time.dd80926d97e613bbbc742bde59cf650d.svg";
export { ForwardRef as ReactComponent };